<script setup>
import { computed, useListeners } from 'vue'

defineProps({
    value: {
        type: [String, Number],
        default: '',
    },
})

const emit = defineEmits(['input'])

const boundListeners = useListeners()

const listeners = computed(() => ({
    ...boundListeners,
    input: event => emit('input', event.target.value),
}))
</script>

<template>
    <div class="base-select">
        <select
            :value="value"
            class="select"
            v-on="listeners"
        >
            <slot />
        </select>
        <div class="arrow">
            <BaseIcon
                class="arrow-icon"
                name="expand_more"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.base-select {
    position: relative;
    overflow: hidden;
    background: $c-mirage-grey;
    border-radius: $size-input-border-radius;
}

.select {
    @extend %input;

    position: relative;
    z-index: 1;
    max-width: unset;
    padding-right: 0;
    margin-bottom: 0;
    background: transparent;
}

.arrow {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
    display: flex;
    align-items: center;
    height: $size-input-height;
    padding: 0 $s-s;
}

.arrow-icon {
    @include square($s-l);

    fill: $c-bali-hai;
}
</style>
